import Nullstack from 'nullstack';
export default function IconPresentationAnalytics({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-presentation-analytics",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9 12v-4"
  }), "   ", Nullstack.element("path", {
    d: "M15 12v-2"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v-1"
  }), "   ", Nullstack.element("path", {
    d: "M3 4h18"
  }), "   ", Nullstack.element("path", {
    d: "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M9 20h6"
  }), " ");
}